import React from 'react'
import { Card, Tooltip} from 'antd';
import { QuestionCircleTwoTone } from '@ant-design/icons';
import ProfileForm from '../../larper/ProfileForm';

export function RegistrationFormProfile({
    originalLarper,
    refreshLarper,
    setProfileSomethingChanged,
    profileSomethingChanged
})  {
    return (
        <Card title="Profile information" >
        <Tooltip title={"This information will be stored in your profile and you can always remove this. This is also optional information"}>
            <QuestionCircleTwoTone />
        </Tooltip>
        {/* <div id="registration-form-profile-header" style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: 12,
        }}> */}

            {/* <h3>{'Profile information  '}</h3>
            <Tooltip title={"This information will be stored in your profile and you can always remove this. This is also optional information"}>
                <QuestionCircleTwoTone />
            </Tooltip> */}
        {/* </div> */}
            <ProfileForm 
                originalLarper={originalLarper}
                refresh={refreshLarper}
                setSomethingChanged={setProfileSomethingChanged}
                somethingChanged={profileSomethingChanged}
            />
        
        </Card>
    )
}